<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapGetters, mapActions } from "vuex";
import AlertError from "@/components/alert_error";
import { VueContentLoading } from "vue-content-loading";
import QrCodeCard from "@/components/qr_code_card";

export default {
  page: {
    title: "أستمارة التطوع",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, AlertError, VueContentLoading, QrCodeCard },
  data() {
    return {
      title: "تفاصيل الاستمارة",
      items: [
        {
          text: "الرئيسيه",
          href: "/",
        },
        {
          text: "أستمارة التطوع",
          href: "/application",
        },
        {
          text: "التفاصيل",
          active: true,
        },
      ],

      //Page errors.
      errors: [],

      id: this.$route.params.id,
      loadingContent: true,
      volunteer: null,
      qrCodeContent: null,
      showAlert: false,
    };
  },
  computed: {
    ...mapGetters("application", ["getVolunteer"]),
  },
  methods: {
    ...mapActions("application", ["get"]),
    handleError(error) {
      alert(error);
      this.showAlert = true;
      if (error.response.status == 422)
        this.errors = Object.values(error.response.data.errors);
      else
        this.errors = [
          `Error Code : ${error.response.status}  Message : ${error.response.data.message}`,
        ];
    },
    hasCertificateDetails(){
      return this.volunteer.certificateInfo.certificate.id >= 8;
    },
    fetch() {
      this.get(this.id)
        .then(() => {
          this.volunteer = this.getVolunteer;
          this.loadingContent = false;

          this.qrCodeContent = JSON.stringify({
            Id: this.volunteer.qr_id,
            fullName: this.volunteer.full_name,
            date: this.volunteer.created_at,
          });
        })
        .catch((error) => {
          this.handleError(error);
          this.loadingContent = false;
        });
    },
  },
  created() {
    this.fetch();
  },
  mounted() {
    // setTimeout(() => {
    //   this.loadingContent = false;
    // }, 1000);
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-md-12">
        <AlertError :showDismissibleAlert="showAlert" :errors="errors"></AlertError>

        <div class="card">
          <div v-if="!loadingContent" class="card-body">
            <hr class="hr-title" />
            <div class="break-title"><h5 class="mb-2">معلومات المتقدم الاساسية</h5></div>
            <div class="row about-list">
              <h4>{{ volunteer.full_name }}</h4>
              <div class="col-md-6">
                <div class="media">
                  <label>اللقب :</label>
                  <p>{{ volunteer.family_name }}</p>
                </div>
                <div class="media">
                  <label>الجنس :</label>
                  <p>{{ volunteer.gender.title }}</p>
                </div>
                <div class="media">
                  <label>تاريخ التولد :</label>
                  <p>{{ volunteer.birth_date }}</p>
                </div>
                <div class="media">
                  <label>التحصيل الدراسي :</label>
                  <p>{{ volunteer.certificateInfo.certificate.title }}</p>
                </div>
                <div v-if="hasCertificateDetails()" class="media">
                  <label> :</label>
                  <p>{{ volunteer.certificateInfo.college }}</p>
                </div>
              </div>
              <div class="col-md-6">
                <div class="media">
                  <label>الحالة الاجتماعية :</label>
                  <p>{{ volunteer.marital_status.title }}</p>
                </div>
                <div class="media">
                  <label>العمل :</label>
                  <p>{{ volunteer.job.title }}</p>
                </div>
                <div class="media">
                  <label>رقم الهاتف :</label>
                  <p>{{ volunteer.phone }}</p>
                </div>
                <div class="media">
                  <label>اللغات التي تتحدثها :</label>
                  <p>{{ volunteer.langs.map((l)=>l.title).join(' , ') }}</p>
                </div>
                <div v-if="hasCertificateDetails()" class="media">
                  <label> :</label>
                  <p>{{ volunteer.certificateInfo.university }}</p>
                </div>
                <div v-if="hasCertificateDetails()" class="media">
                  <label> :</label>
                  <p>{{ volunteer.certificateInfo.level.title }}</p>
                </div>
              </div>
            </div>

            <hr class="hr-title" />
            <div class="break-title"><h5 class="mb-2">عنوان السكن</h5></div>
            <div class="row about-list">
              <div class="col-md-6">
                <div class="media">
                  <label>المحافظة :</label>
                  <p>{{ volunteer.address.city.title }}</p>
                </div>
                <div class="media">
                  <label>مكان الاقامة الحالي :</label>
                  <p>{{ volunteer.address.currrent }}</p>
                </div>
              </div>
              <div class="col-md-6">
                <div class="media">
                  <label>القضاء :</label>
                  <p>{{ volunteer.address.district }}</p>
                </div>
                <div class="media">
                  <label>اقرب نقطة دالة :</label>
                  <p>{{ volunteer.address.nearest_point }}</p>
                </div>
              </div>
            </div>

            <hr class="hr-title" />
            <div class="break-title"><h5 class="mb-2">المهارات والاعمال التطوعية</h5></div>
            <div class="row about-list">
              <div class="col-md-6">
                <div class="question-content">
                  <div class="quest">
                   <img src="@/assets/images/users/bluequestion.png" alt="">
                   <label>ما هي المهارات والمواهب والخبرات التي تملكها ؟ </label>
                  </div>
                  <p>{{ volunteer.question.question_1_skills }}</p>
                </div>
                <div class="question-content">
                  <div class="quest">
                   <img src="@/assets/images/users/bluequestion.png" alt="">
                   <label>اذا كان لديك مساهمات بدعم الحشد سابقاً سواء كانت مساهمات اعلامية او لوجستية او طبية او اي شكل من اشكال الدعم اذكرها , وتكلم عن تجربتك بدعم الحشد :</label>
                  </div>
                  <p>{{ volunteer.question.question_2_contributions }}</p>
                </div>
                <div class="question-content">
                  <div class="quest">
                 <img src="@/assets/images/users/bluequestion.png" alt="">
                  <label>هل لديك أقارب أو أصدقاء في الحشد الشعبي ؟ ( اذكر اسماءهم و ارقام هواتفهم واماكن عملهم ان وجدت ) :</label>
                  </div>
                  <p>{{ volunteer.question.question_3_friends }}</p>
                </div>
                <div class="question-content">
                  <div class="quest">
                 <img src="@/assets/images/users/bluequestion.png" alt="">
                  <label>كيف حصلت على رابط الاستمارة ؟ ( اذكر اسم الصديق او المنصة الاعلامية التي حصلت من خلالها على الرابط ) :</label>
                  </div>
                  <p>{{ volunteer.question.question_4_link }}</p>
                </div>
                </div>
                <div class="col-md-6">
                <div class="question-content">
                  <div class="quest">
                 <img src="@/assets/images/users/bluequestion.png" alt="">
                  <label>تكلم عن تجربتك في العمل التطوعي ( اذكر اسم فريق العمل التطوعي او المنظمة التي عملت فيها او التجربة التطوعية الفردية ان وجدت ) :</label>
                  </div>
                  <p>{{ volunteer.question.question_5_experience }}</p>
                </div>
                <div class="question-content">
                  <div class="quest">
                 <img src="@/assets/images/users/bluequestion.png" alt="">
                  <label>ما هي الخدمات التطوعية التي تحب تقديمها للمجتمع ؟ (مثلا: عن طريق الاعلام , الفن , او عن طريق المهن الحرفية او التدريب او اي خدمة تستطيع ان تبدع في تقديمها) :</label>
                 </div>
                  <p>{{ volunteer.question.question_6_services }}</p>
                </div>
                <div class="question-content">
                  <div class="quest">
                 <img src="@/assets/images/users/bluequestion.png" alt="">
                  <label>كم ساعة او يوم تستطيع تقديمها لخدمة الناس بشكل تطوعي ؟ </label>
                  </div>
                  <p>{{ volunteer.question.question_7_hours_days }}</p>
                </div>
                <div class="question-content">
                  <div class="quest">
                 <img src="@/assets/images/users/bluequestion.png" alt="">
                  <label>اذكر اي تفاصيل تود اضافتها :</label>
                  </div>
                  <p>{{ volunteer.question.details }}</p>
                </div>
              </div>
            </div>

            <hr class="hr-title" />
            <div class="break-title"><h5 class="mb-2">مواقع التواصل الاجتماعي</h5></div>
            <div class="row about-list">
              <div class="col-md-12">
                <div class="media">
                  <label>حساب التلكرام :</label>
                  <p>{{ volunteer.social_media.link_telegram }}</p>
                </div>
                <div class="media">
                  <label>حساب الفيسبوك :</label>
                  <p>{{ volunteer.social_media.link_facebook }}</p>
                </div>
                <div class="media">
                  <label>حساب الانستكرام :</label>
                  <p>{{ volunteer.social_media.link_instagram }}</p>
                </div>
                <div class="media">
                  <label>حساب تويتر :</label>
                  <p>{{ volunteer.social_media.link_twitter }}</p>
                </div>
              </div>
            </div>
            <hr class="hr-title" />
          

            <QrCodeCard
              title="أستمارة التطوع"
              :fullName="this.volunteer.full_name"
              :date="this.volunteer.created_at"
              :Id="this.volunteer.qr_id"
              :qrCodeContent="this.qrCodeContent"
            ></QrCodeCard>

            <div class="mt-3">
              <hr />
              <b-button class="" type="button" to="/application" variant="secondary"
                >رجوع</b-button
              >
            </div>
          </div>

          <!-- loading content -->
          <div v-else>
            <vue-content-loading :rtl="true" :width="400" :height="110">
              <rect x="85" y="10" rx="1" ry="1" width="30" height="2" />
              <rect x="275" y="10" rx="1" ry="1" width="30" height="2" />
              <rect x="6" y="15" rx="1" ry="1" width="194" height="2" />
              <rect x="200" y="16" rx="1" ry="1" width="194" height="1" />

              <rect x="10" y="25" rx="1" ry="1" width="50" height="5" />
              <rect x="340" y="25" rx="1" ry="1" width="50" height="5" />

              <rect x="10" y="40" rx="2" ry="2" width="45" height="5" />
              <rect x="66" y="40" rx="2" ry="2" width="45" height="5" />
              <rect x="122" y="40" rx="2" ry="2" width="45" height="5" />
              <rect x="178" y="40" rx="2" ry="2" width="45" height="5" />
              <rect x="234" y="40" rx="2" ry="2" width="45" height="5" />
              <rect x="290" y="40" rx="2" ry="2" width="45" height="5" />
              <rect x="346" y="40" rx="2" ry="2" width="44" height="5" />
              <rect x="10" y="49" rx="1" ry="1" width="380" height="1" />

              <rect x="10" y="54" rx="2" ry="2" width="45" height="5" />
              <rect x="66" y="54" rx="2" ry="2" width="45" height="5" />
              <rect x="122" y="54" rx="2" ry="2" width="45" height="5" />
              <rect x="178" y="54" rx="2" ry="2" width="45" height="5" />
              <rect x="234" y="54" rx="2" ry="2" width="45" height="5" />
              <rect x="290" y="54" rx="2" ry="2" width="45" height="5" />
              <rect x="346" y="54" rx="2" ry="2" width="44" height="5" />
              <rect x="10" y="63" rx="1" ry="1" width="380" height="1" />

              <rect x="10" y="68" rx="2" ry="2" width="45" height="5" />
              <rect x="66" y="68" rx="2" ry="2" width="45" height="5" />
              <rect x="122" y="68" rx="2" ry="2" width="45" height="5" />
              <rect x="178" y="68" rx="2" ry="2" width="45" height="5" />
              <rect x="234" y="68" rx="2" ry="2" width="45" height="5" />
              <rect x="290" y="68" rx="2" ry="2" width="45" height="5" />
              <rect x="346" y="68" rx="2" ry="2" width="44" height="5" />
              <rect x="10" y="77" rx="1" ry="1" width="380" height="1" />

              <rect x="10" y="82" rx="2" ry="2" width="45" height="5" />
              <rect x="66" y="82" rx="2" ry="2" width="45" height="5" />
              <rect x="122" y="82" rx="2" ry="2" width="45" height="5" />
              <rect x="178" y="82" rx="2" ry="2" width="45" height="5" />
              <rect x="234" y="82" rx="2" ry="2" width="45" height="5" />
              <rect x="290" y="82" rx="2" ry="2" width="45" height="5" />
              <rect x="346" y="82" rx="2" ry="2" width="44" height="5" />
              <rect x="10" y="91" rx="1" ry="1" width="380" height="1" />
              <circle cx="340" cy="100" r="1" />
              <circle cx="350" cy="100" r="1" />
              <circle cx="363" cy="100" r="4" />
              <circle cx="376" cy="100" r="1" />
              <circle cx="386" cy="100" r="1" />
            </vue-content-loading>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
